import React from "react";
import bg from "../../assets/bg.png";
import { styled } from "@mui/system";
import ContactForm from "./modals/ContactForm";
import { Grid, Typography, Box, ListItem, ListItemText } from "@mui/material";
import CircleIcon from "@mui/icons-material/Circle";

const TopSection = styled(Box)(({ theme }) => ({
  backgroundImage: `url(${bg})`,
  backgroundSize: "100% auto",
  aspectRatio: "16/9",
  backgroundRepeat: "no-repeat",
  backgroundPosition: "center",
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  position: "relative",

  [[theme.breakpoints.between("xs", "sm")]]: {
    backgroundImage: "none",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "center",
  },
  [[theme.breakpoints.between("sm", "md")]]: {
    backgroundImage: "none",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "center",
  },
  [[theme.breakpoints.between("md", "lg")]]: {
    // flexDirection: "column",
    //
    // justifyContent: "flex-start",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "top",
  },
  [theme.breakpoints.up("lg")]: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "top",

    // height: "100%",
    // minHeight: "100vh",
  },
}));

const BgImageContainer = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  zIndex: 1,
  backgroundColor: "rgba(0, 0, 0, 0.7)",
  [[theme.breakpoints.between("xs", "sm")]]: {
    display: "none",
  },
  [[theme.breakpoints.between("sm", "md")]]: {
    display: "none",
  },
}));

const TextContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "flex-start",
  textAlign: "left",
  margin: theme.spacing(2),
  position: "relative",
  zIndex: 1,
  [[theme.breakpoints.between("xs", "sm")]]: {
    width: "100%",
    padding: "16px 0px",
    margin: 0,
  },
  [[theme.breakpoints.between("sm", "md")]]: {
    width: "100%",
    padding: "16px 0px",
    margin: 0,
  },
  [[theme.breakpoints.between("md", "lg")]]: {
    width: "50%",
  },
  [theme.breakpoints.up("lg")]: {
    width: "50%",
  },
}));

const TextImageContainer = styled(Box)(({ theme }) => ({
  backgroundImage: `url(${bg})`,
  backgroundSize: "100% auto",
  backgroundRepeat: "no-repeat",
  backgroundPosition: "center",
  backgroundSize: "cover",
  position: "absolute",
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
  zIndex: -1,
  filter: "brightness(50%) blur(5px)",
  [[theme.breakpoints.between("xs", "sm")]]: {
    width: "100%",
  },
  [[theme.breakpoints.between("sm", "md")]]: {
    width: "100%",
  },
  [[theme.breakpoints.between("md", "lg")]]: {
    backgroundImage: "none",
  },
  [theme.breakpoints.up("lg")]: {
    backgroundImage: "none",
  },
}));

const FormContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-end",
  margin: theme.spacing(2),
  zIndex: 2,
  [[theme.breakpoints.between("xs", "sm")]]: {
    // width: "100%",
  },
  [[theme.breakpoints.between("sm", "md")]]: {
    width: "70%",
  },
  [theme.breakpoints.up("md")]: {
    width: "35%",
  },
}));

const Title = styled(Typography)(({ theme }) => ({
  textAlign: "center",
  component: "h1",
  width: "100%",
  color: "#F47720",

  [[theme.breakpoints.between("xs", "sm")]]: {
    font: "normal normal 700 18px open sans",
    marginBottom: theme.spacing(2),
  },
  [[theme.breakpoints.between("sm", "md")]]: {
    font: "normal normal 700 24px open sans",
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(4),
  },
  [[theme.breakpoints.between("md", "lg")]]: {
    font: "normal normal 700 36px open sans",
    textAlign: "left",
    color: "#ffffff",
  },
  [theme.breakpoints.up("lg")]: {
    font: "normal normal 700 48px open sans",
    textAlign: "left",
    color: "#ffffff",
  },
}));

const Circle = styled(CircleIcon)(({ theme }) => ({
  fontSize: "8px",

  [[theme.breakpoints.between("xs", "md")]]: {
    fontSize: "4xp",
    color: "#ffffff",
  },
  [[theme.breakpoints.between("md", "lg")]]: {
    fontSize: "8px",
    color: "#ffffff",
  },
  [theme.breakpoints.up("lg")]: {
    fontSize: "12px",
    color: "#ffffff",
  },
}));
const StyledListItemText = styled(ListItemText)(({ theme }) => ({
  "& .MuiTypography-root": {
    font: "normal normal 400 16px open sans",
    paddingLeft: theme.spacing(2),
    paddingTop: 0,
    component: "span",
    color: "#000000",
    [[theme.breakpoints.between("xs", "sm")]]: {
      font: "normal normal 400 12px open sans",
      component: "span",
      color: "#ffffff",
    },
    [[theme.breakpoints.between("sm", "md")]]: {
      font: "normal normal 400 12px open sans",
      component: "span",
      color: "#ffffff",
    },
    [[theme.breakpoints.between("md", "lg")]]: {
      font: "normal normal 400 16px open sans",
      component: "span",
      color: "#ffffff",
    },
    [theme.breakpoints.up("lg")]: {
      font: "normal normal 400 20px open sans",
      component: "span",
      color: "#ffffff",
    },
  },
}));

const HighlightConditionText = styled(Typography)(({ theme }) => ({
  paddingLeft: theme.spacing(2),
  paddingTop: 0,
  component: "span",
  color: "#000000",
  marginLeft: "12px",
  font: "normal normal 400 12px open sans",
  position: "absolute",
  bottom: "-10px",
  [[theme.breakpoints.between("xs", "sm")]]: {
    component: "span",
    color: "#ffffff",
    marginLeft: "8px",
    font: "normal normal 400 8px open sans",
  },
  [[theme.breakpoints.between("sm", "md")]]: {
    component: "span",
    color: "#ffffff",
    marginLeft: "8px",
    font: "normal normal 400 8px open sans",
  },
  [[theme.breakpoints.between("md", "lg")]]: {
    component: "span",
    color: "#ffffff",
  },
  [theme.breakpoints.up("lg")]: {
    component: "span",
    color: "#ffffff",
  },
}));

const ListItemContainer = styled(Box)(({ theme }) => ({
  position: "relative",
  width: "100%",
  [[theme.breakpoints.down("sm")]]: {
    width: "50%",
  },
  [[theme.breakpoints.between("xs", "md")]]: {
    paddingLeft: theme.spacing(1),
    margin: "auto",
    marginBottom: "10px",
  },
  [theme.breakpoints.up("md")]: {
    paddingLeft: theme.spacing(4),
  },
}));

const MyTopSection = () => {
  return (
    <TopSection>
      <BgImageContainer />
      <TextContainer>
        <TextImageContainer />
        <Title>Personal Loans</Title>
        <ListItemContainer>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={1}
            rowSpacing={{ xs: 0, sm: 0, md: 0, lg: 0, xl: 0 }}
            columnSpacing={{ xs: 1, sm: 1, md: 1, lg: 0, xl: 0 }}
          >
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <ListItem disablePadding style={{ textAlign: "start" }}>
                <Circle />
                <StyledListItemText primary="ROI of 10.5%" />
              </ListItem>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <ListItem disablePadding style={{ textAlign: "start" }}>
                <Circle />
                <StyledListItemText primary="Zero Part Payment* & Pre Closure Charges" />
              </ListItem>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <ListItem disablePadding style={{ textAlign: "start" }}>
                <Circle />
                <StyledListItemText primary="Loan Up to 40 Lakhs" />
              </ListItem>
            </Grid>
          </Grid>
          <HighlightConditionText>( Conditions apply )</HighlightConditionText>
        </ListItemContainer>
      </TextContainer>
      <FormContainer>
        <ContactForm />
      </FormContainer>
    </TopSection>
  );
};

export default MyTopSection;
